module.exports = __webpack_public_path__ + "fe4de7aeda3abed04c238956a8565de4.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./~/ace-builds/src-noconflict/mode-golang.js
// module id = 1186
// module chunks = 0